module.exports = __webpack_public_path__ + "media/packs/images/flags/BE-3ab8f5fa856b1ccd374d59bd14410cf9.svg";